module.exports = __webpack_public_path__ + "img/a09.d8d3a18a.png";